import { useTranslation } from "react-i18next";

import { SEO } from "../components/SEO";
import { ExploreMap } from "../sections/ExploreMap";
import { FAQ } from "../sections/FAQ";
import { Features } from "../sections/Features";
import { FinalCTA } from "../sections/FinalCTA";
import { ForAgencies } from "../sections/ForAgencies";
import { Hero } from "../sections/Hero";
import { HowItWorks } from "../sections/HowItWorks";

export function Home() {
  const { t } = useTranslation();

  return (
    <main>
      <SEO
        title={t("meta.tab_title")}
        socialTitle={t("meta.home_title")}
        description={t("meta.home_description")}
        socialDescription={t("meta.home_social_description")}
        path="/"
      />

      <Hero />
      <ExploreMap />
      <Features />
      <HowItWorks />
      <ForAgencies />
      <FAQ />
      <FinalCTA />
    </main>
  );
}
